import React from 'react';
import { useForm, usePage } from '@inertiajs/react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import ValidationError from '../../components/ValidationError';
import { useTrans } from '../../hooks/useTrans';

export default function ConfirmPassword() {
    const translate = useTrans();
    const { flash } = usePage().props;

    const { data, setData, post, processing, errors } = useForm({
        password: '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        post('/wachtwoord-bevestigen');
    }

    return (
        <div className="max-w-[1200px] mx-auto px-4">
            <div className="rounded-[3px] border border-[#bbb] bg-white">
                <div className="p-[30px]">
                    <form onSubmit={handleSubmit}>
                        <h3 className="text-2xl font-bold text-[#003545] mb-4">
                            {translate('Bevestig je wachtwoord om verder te gaan')}
                        </h3>
                        <p className="text-sm text-[#003545] mb-4">
                            {translate('Om deze pagina te bekijken, dien je eerst je wachtwoord bevestigen.')}
                        </p>

                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <label className="sm:w-[217px] shrink-0 text-sm font-bold text-[#003545] mb-1 sm:mb-0" htmlFor="password">
                                {translate('Wachtwoord')}&nbsp;<sup>*</sup>
                            </label>
                            <div className="w-full sm:w-[352px]">
                                <Input
                                    id="password"
                                    type="password"
                                    value={data.password}
                                    onChange={(e) => setData('password', e.target.value)}
                                    required
                                    className="h-[44px] font-normal"
                                />
                                <ValidationError message={errors.password} />
                            </div>
                        </div>

                        <hr className="my-7 border-[#ddd]" />

                        <div className="flex justify-end">
                            <Button variant="primary" type="submit" disabled={processing}>
                                {translate('Doorgaan')}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
